import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";
import dayjs from "dayjs";
import Layout from "../../components/layout/Layout";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Menu,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState } from "react";
import useTable from "../../components/customHelpers/usePaginationTable";
import Notify from "../../components/customHelpers/Notify";
import PurchaseProduct from "../../actions/purchaseProduct";
import Admin from "../../components/auth/Admin";

import CancelIcon from "@mui/icons-material/Cancel";
import Notification from "../../components/customHelpers/Notification";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import jsPDF from "jspdf";
import DownloadIcon from "@mui/icons-material/Download";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { formatNumber, getTimestamp, pageSizes } from "../../utils/utils";
import ClearIcon from "@mui/icons-material/Clear";
import { PurchaseOrder } from "../../actions/purchaseOrder";
const initialHeadCells = [
  { id: "name", label: "Product Name", isVisible: true },
  { id: "sku", label: "Sku", isVisible: true },
  { id: "price", label: "Price", isVisible: true },
  { id: "quantity", label: "Quantity", isVisible: true },
  { id: "container", label: "Container", isVisible: true },
  { id: "order", label: "Order", isVisible: true },
  { id: "totalPrice", label: "Total Price", isVisible: true },
  { id: "createdAt", label: "CreatedAt", isVisible: true },
];

const ContainerReport = () => {
  const [headCells, setHeadCells] = useState(initialHeadCells);
  const hiddenColumns = headCells.filter((cell) => !cell.isVisible);
  const { NotifyMessage, notify, setNotify } = Notify();
  const {
    viewAllPurchasesByContainerWithPages,
    viewAllPurchasesByContainer,
    viewTotalPriceByContainer,
  } = PurchaseProduct();

  const [containerProduct, setContainerProduct] = useState([]);
  const [temp, setTemp] = useState([]);
  const [selectedContainer, setSelectedContainer] = useState(null);
  const [order, setSelectedOrder] = useState(null);
  const [page, setPage] = useState(1);
  const [tot, setTot] = useState(1);
  const [limit, setLimit] = useState(pageSizes[1]);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [actualTotal, setActualTotal] = useState();
  const [records, setRecords] = useState([]);
  const { viewAllPurchaseOrders } = PurchaseOrder();
  const [totalPrice, setTotalPrice] = useState({
    totalPrice: 0,
    isClick: true,
  });
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;

  useEffect(() => {
    getProductsByContainerWithPages();
  }, [page, limit, searchQuery, selectedContainer, order, null]);
  useEffect(() => {
    getProductsByContainer();
  }, []);
  useEffect(() => {
    getTotalPrice();
  }, [selectedContainer, order]);
  const getTotalPrice = () => {
    viewTotalPriceByContainer(selectedContainer || "", order?.id || "").then(
      (data) => {
        if (data.err) {
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        } else if (data.totalPrice) {
          setTotalPrice({
            totalPrice: data.totalPrice || 0,
            isClick: true,
          });
        }
      }
    );
  };
  const getProductsByContainerWithPages = () => {
    viewAllPurchasesByContainerWithPages(
      page,
      limit,
      searchQuery,
      selectedContainer,
      order?.id || "",
      null
    ).then((data) => {
      if (data.err) {
        NotifyMessage({ message: data.err, type: "error" });
      } else if (data.product) {
        setValues({ ...values, loading: false });
        setContainerProduct(data.product);
        setTotalPages(Math.ceil(data.total / limit));
        setActualTotal(data.pagination.total);
        setTot(data.pagination.totalPages);
      }
    });
  };
  const getProductsByContainer = () => {
    viewAllPurchasesByContainer().then((data) => {
      if (data.err) {
        NotifyMessage({ message: data.err, type: "error" });
      } else if (data.product) {
        setValues({ ...values, loading: false });
        setTemp(data.product);
      }
    });
  };

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterSortingAndFiltering,
  } = useTable(containerProduct, initialHeadCells, filterFn);
  const uniqueContainerNames = [...new Set(temp?.map((item) => item.name))];

  const generateReportFilename = (containerName, timestamp) => {
    return `${containerName}_Purchase-report_${timestamp}`;
  };

  const exportToExcel = () => {
    const filteredHeadCells = headCells.filter((cell) => cell.isVisible);
    const dataToExport = containerProduct.map((item) =>
      filteredHeadCells.map((cell) => {
        switch (cell.id) {
          case "name":
            return item.purchaseList?.name;
          case "sku":
            return item.purchaseList?.sku;
          case "price":
            return item.purchaseList.price;
          case "quantity":
            return item.quantity;
          case "container":
            return item.name;
          case "totalPrice":
            return item.purchaseList.price * item.quantity;
          case "createdAt":
            return new Date(item.createdAt).toLocaleString();
          default:
            return "";
        }
      })
    );

    const totalPriceSum = containerProduct.reduce((sum, item) => {
      return sum + item.purchaseList.price * item.quantity;
    }, 0);

    dataToExport.push([
      "Total Price",
      formatNumber(totalPriceSum.toFixed(2)),
      "",
      "",
      "",
      "",
      "",
      "",
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      filteredHeadCells.map((cell) => cell.label),
      ...dataToExport,
    ]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Order");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const timestamp = getTimestamp();
    const filename = generateReportFilename(selectedContainer, timestamp);
    saveAs(blob, `${filename}.xlsx`);
    handleClose();
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    const filteredHeadCells = headCells.filter((cell) => cell.isVisible);
    const totalPriceSum = containerProduct.reduce((sum, item) => {
      return sum + item.purchaseList.price * item.quantity;
    }, 0);

    const bodyData = containerProduct.map((item) =>
      filteredHeadCells.map((cell) => {
        switch (cell.id) {
          case "name":
            return item.purchaseList?.name;
          case "sku":
            return item.purchaseList?.sku;
          case "price":
            return item.purchaseList.price;
          case "quantity":
            return item.quantity;
          case "container":
            return item.name;
          case "totalPrice":
            return formatNumber(item.purchaseList.price * item.quantity);
          case "createdAt":
            return new Date(item.createdAt).toLocaleString();
          default:
            return "";
        }
      })
    );

    doc.autoTable({
      head: [filteredHeadCells.map((cell) => cell.label)],
      body: bodyData,
      styles: { fontSize: 10 },
      headStyles: {
        fillColor: [244, 151, 3],
        textColor: [20, 61, 89],
      },
    });

    const finalY = doc.lastAutoTable.finalY || 10;
    doc.text(
      `Total Price: ${formatNumber(totalPriceSum.toFixed(2))}`,
      doc.internal.pageSize.getWidth() - 20,
      finalY + 10,
      { align: "right" }
    );

    const timestamp = getTimestamp();
    const filename = generateReportFilename(selectedContainer, timestamp);
    doc.save(`${filename}.pdf`);
    handleClose();
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const visibleColumns = headCells.filter((cell) => cell.isVisible);

  const handleColumnToggle = (id) => {
    const updatedHeadCells = headCells.map((cell) =>
      cell.id === id ? { ...cell, isVisible: !cell.isVisible } : cell
    );
    setHeadCells(updatedHeadCells);
  };

  const clearFilters = () => {
    setPage(1);
    setSelectedContainer(null);
    setSelectedOrder(null);
  };

  const handleContainerChange = (e) => {
    setPage(1);
    setSelectedContainer(e);
  };
  const handleOrderChange = (e) => {
    setPage(1);
    setSelectedOrder(e);
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };
  const startIndex = (page - 1) * limit + 1;
  const endIndex = Math.min(startIndex + limit - 1, actualTotal);

  useEffect(() => {
    loadPurchaseOrders();
  }, []);

  const loadPurchaseOrders = () => {
    setValues({ ...values, loading: true });
    viewAllPurchaseOrders()
      .then((response) => {
        if (response.err) {
          NotifyMessage({
            message: response.err,
            type: "error",
          });
        } else {
          setRecords(response.purchaseOrder);
          setValues({ ...values, loading: false });
        }
      })
      .catch((err) => {
        NotifyMessage({
          message: "Failed to fetch purchase orders",
          type: "error",
        });
        setValues({ ...values, loading: false });
      })
      .finally(() => {
        setValues({ ...values, loading: false });
      });
  };
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Purchase Orders Report
          </Typography>

          <Box
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            justifyContent={{ xs: "flex-start" }}
            alignItems={{ xs: "stretch", sm: "center" }}
            gap={2}
            m={1}
            p={1}
          >
            <Autocomplete
              options={uniqueContainerNames}
              value={selectedContainer || null}
              onChange={(event, newValue) => handleContainerChange(newValue)}
              renderInput={(params) => (
                <TextField {...params} label="Filter By Container" />
              )}
              sx={{
                width: { xs: "100%", sm: "20%" },
                "& .MuiInputBase-root": { height: 48 },
              }}
            />
            <Autocomplete
              options={records}
              getOptionLabel={(option) => option.name}
              value={order || null}
              onChange={(event, newValue) => handleOrderChange(newValue)}
              sx={{
                width: { xs: "100%", sm: "20%" },
                "& .MuiInputBase-root": { height: 48 },
              }}
              renderInput={(params) => (
                <TextField {...params} label="Filter By Order" />
              )}
            />

            <Box
              display="flex"
              justifyContent={{ xs: "flex-start", sm: "flex-end" }}
              gap={1}
              sx={{ width: { xs: "100%", sm: "auto" } }}
            >
              {" "}
              <Box>
                <Button
                  variant="contained"
                  onClick={clearFilters}
                  endIcon={<CancelIcon />}
                  sx={{
                    backgroundColor: "rgba(244,151,3,.8)",
                    color: "rgb(20,61,89)",
                    "&:hover": {
                      backgroundColor: "rgba(244,151,3,.8)",
                      color: "rgb(20,61,89)",
                    },
                  }}
                >
                  Clear
                </Button>
              </Box>
              <Box sx={{ width: "27%" }}>
                <Button
                  variant="contained"
                  id="demo-positioned-button"
                  aria-controls={open ? "demo-positioned-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  startIcon={<DownloadIcon />}
                  sx={{
                    backgroundColor: "rgba(244,151,3,.8)",
                    color: "rgb(20,61,89)",
                    "&:hover": {
                      backgroundColor: "rgba(244,151,3,.8)",
                      color: "rgb(20,61,89)",
                    },
                  }}
                >
                  Export
                </Button>
                <Menu
                  id="demo-positioned-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <MenuItem onClick={exportToPDF}>PDF</MenuItem>
                  <MenuItem onClick={exportToExcel}>Excel</MenuItem>
                </Menu>
              </Box>
            </Box>
          </Box>

          <Grid container spacing={2}>
            {isMobile && hiddenColumns.length > 0 && (
              <Grid item xs={12} sx={{ display: { xs: "block", sm: "none" } }}>
                <Typography variant="h6">Hidden Columns</Typography>
                <FormGroup sx={{ marginTop: 0 }}>
                  {hiddenColumns.map((headCell, index) => (
                    <FormControlLabel
                      key={headCell.id}
                      control={
                        <Checkbox
                          sx={{
                            "& .MuiSvgIcon-root": {
                              backgroundColor: "transparent",
                            },
                          }}
                          checked={!headCell.isVisible}
                          onChange={() => handleColumnToggle(headCell.id)}
                        />
                      }
                      label={headCell.label}
                      sx={{
                        marginBottom:
                          index === hiddenColumns.length - 1 ? 0 : 1,
                        "& .MuiFormControlLabel-label": {
                          marginTop: 0,
                        },
                      }}
                    />
                  ))}
                </FormGroup>
              </Grid>
            )}
            <Grid
              item
              xs={12}
              sm={hiddenColumns.length > 0 ? 9 : 12}
              className="card__body"
            >
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <Table>
                      <TableHead>
                        <TableRow
                          sx={{
                            height: "30px", // Set row height
                            maxHeight: "30px",
                            minHeight: "30px",
                          }}
                        >
                          {visibleColumns.map((headCell) => (
                            <TableCell
                              style={{
                                width: headCell.isVisible ? "auto" : "0",
                                fontWeight: 600,
                                color: "rgb(20,61,89)",
                                backgroundColor: "rgba(244,151,3,.8)",
                                fontSize: "1.3rem",
                                lineHeight: "1.2rem",
                                padding: "2px 4px",
                                height: "30px",
                                maxHeight: "30px",
                                minHeight: "30px",
                              }}
                              key={headCell.id}
                              className={
                                headCell.isVisible
                                  ? "table-cell-visible"
                                  : "table-cell-hidden"
                              }
                              sx={{
                                width: headCell.isVisible ? "auto" : "0",
                                fontWeight: 600,
                                color: "rgb(20,61,89)",
                                backgroundColor: "rgba(244,151,3,.8)",
                                fontSize: "1.3rem",
                                lineHeight: "1.2rem",
                                padding: "2px 4px",
                                height: "30px",
                                maxHeight: "30px",
                                minHeight: "30px",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  gap: 0.5,
                                  height: "100%",
                                  "& .MuiSvgIcon-root": {
                                    fontSize: "1rem", // Smaller icons
                                  },
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  noWrap
                                  style={{
                                    fontWeight: 600,
                                    fontSize: "0.9rem",
                                    lineHeight: "1rem",
                                  }}
                                >
                                  {headCell.label}
                                </Typography>

                                <Checkbox
                                  checked={headCell.isVisible}
                                  onChange={() =>
                                    handleColumnToggle(headCell.id)
                                  }
                                  icon={
                                    <CheckBoxOutlineBlankIcon fontSize="small" />
                                  }
                                  checkedIcon={<CancelIcon fontSize="small" />}
                                  sx={{
                                    p: 0,
                                    m: 0,
                                    "& .MuiSvgIcon-root": {
                                      fontSize: "1rem", // Force icon size
                                    },
                                  }}
                                />
                              </Box>
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {recordsAfterSortingAndFiltering().length > 0 ? (
                          recordsAfterSortingAndFiltering().map((item) => (
                            <TableRow key={item.id}>
                              {visibleColumns.map((headCell) => (
                                <TableCell key={headCell.id}>
                                  {headCell.id === "name"
                                    ? item.purchaseList?.name
                                    : headCell.id === "sku"
                                    ? item.purchaseList?.sku
                                    : headCell.id === "price"
                                    ? item.purchaseList?.price
                                    : headCell.id === "quantity"
                                    ? item.quantity
                                    : headCell.id === "container"
                                    ? item.name
                                    : headCell.id === "order"
                                    ? item.purchaseList?.purchaseOrder?.name
                                    : headCell.id === "totalPrice"
                                    ? formatNumber(
                                        parseFloat(
                                          item.purchaseList?.price?.replace(
                                            /[, ]/g,
                                            ""
                                          )
                                        ) *
                                          (parseInt(
                                            item.quantity
                                              .toString()
                                              .replace(/[, ]/g, ""),
                                            10
                                          ) || 0)
                                      )
                                    : headCell.id === "createdAt"
                                    ? new Date(item.createdAt).toLocaleString()
                                    : null}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))
                        ) : (
                          <Norecords col={6} />
                        )}
                      </TableBody>
                    </Table>
                  </TblContainer>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      p: 2,
                      backgroundColor: "background.paper",
                      borderTop: 1,
                      borderColor: "divider",
                      gap: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
                      <Typography variant="body2" sx={{ mr: 1 }}>
                        Rows per page:
                      </Typography>
                      <Select
                        value={limit}
                        onChange={handlePageSizeChange}
                        size="small"
                        sx={{ minWidth: 120 }}
                      >
                        {pageSizes.map((size) => (
                          <MenuItem key={size} value={size}>
                            {size}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    {actualTotal && (
                      <span>
                        {" "}
                        {startIndex}-{endIndex} of {actualTotal}
                      </span>
                    )}
                    {containerProduct.length > 0 && (
                      <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        hideNextButton={page === tot}
                        hidePrevButton={page === 1}
                        shape="rounded"
                        siblingCount={1}
                      />
                    )}
                  </Box>{" "}
                  <Box display="flex" justifyContent="end" gap={2} m={1} p={1}>
                    <div
                      style={{
                        marginRight: "35px",
                        fontWeight: "bold",
                        fontSize: "15px",
                      }}
                    >
                      Total Price: {formatNumber(totalPrice.totalPrice)}
                    </div>
                  </Box>
                </Paper>
              )}
            </Grid>
            {!isMobile && hiddenColumns.length > 0 && (
              <Grid
                item
                xs={2}
                sx={{ display: { xs: "none", sm: "block" }, marginLeft: 10 }}
              >
                <Typography variant="h6">Hidden Columns</Typography>
                <Grid container spacing={1}>
                  {hiddenColumns.map((headCell, index) => (
                    <Grid item xs={6} key={headCell.id}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            sx={{
                              "& .MuiSvgIcon-root": {
                                backgroundColor: "transparent",
                              },
                            }}
                            checked={!headCell.isVisible}
                            onChange={() => handleColumnToggle(headCell.id)}
                          />
                        }
                        label={headCell.label}
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            marginTop: 0,
                          },
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            )}
            <Notification notify={notify} setNotify={setNotify} />
          </Grid>
        </div>
      </Admin>
    </Layout>
  );
};

export default ContainerReport;
